module.exports = __webpack_public_path__ + "static/img/drone_01.504b21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/drone_01.jpg
// module id = qcVA
// module chunks = 0